<template>
  <div v-if="isLayerImage" style="margin: 0px 7px" title="Lớp dạng chữ">
    <v-img :src="item.image_url" contain :max-width="size" :max-height="size">
    </v-img>
  </div>
  <div v-else-if="isLayerText" style="margin: 0px 7px" title="Lớp dạng chữ">
    <v-icon :size="size"> mdi-format-text </v-icon>
  </div>
  <div v-else-if="isLayerRaster" style="margin: 0px 7px" title="Lớp dạng ảnh">
    <v-icon :size="size"> mdi-image </v-icon>
  </div>
  <div
    v-else
    class="flex-center"
    :style="`height: ${size}px;width: ${size * 1 + 14}px;`"
    :title="`Lớp dạng: ${layer.type}`"
  >
    <div :style="getStyleForLegend"></div>
  </div>
</template>

<script>
export default {
  props: {
    layer: {
      required: true,
    },
    item: {
      required: true,
    },
  },
  data: () => ({
    size: '24',
  }),
  computed: {
    isLayerText() {
      return (
        this.layer &&
        this.layer.type == 'symbol' &&
        this.layer.layout['text-field']
      )
    },
    isLayerImage() {
      return this.layer && this.layer.type == 'symbol' && this.item.image_url
    },
    isLayerRaster() {
      return this.layer && this.layer.type == 'raster'
    },
    getStyleForLegend() {
      const layer = this.layer
      switch (layer.type) {
        case 'background':
          return {
            width: `${this.size - 10}px`,
            height: `${this.size - 10}px`,
            margin: '0px 7px',
            backgroundColor: layer.paint['background-color'] || '#000000',
          }
        case 'fill':
          return {
            width: `${this.size}px`,
            height: `${this.size - 10}px`,
            margin: '0px 7px',
            backgroundColor: layer.paint['fill-color'] || '#000000',
            border: `1px solid ${layer.paint['fill-outline-color'] ||
              '#000000'}`,
          }
        case 'line':
          return {
            width: `${this.size - 10}px`,
            height: `2px`,
            margin: '0px 7px',
            backgroundColor: layer.paint['line-color'] || '#000000',
          }
        case 'circle':
          return {
            width: `${this.size - 10}px`,
            height: `${this.size - 10}px`,
            margin: '0px 7px',
            backgroundColor: layer.paint['circle-color'] || '#000000',
            borderRadius: '50%',
          }
        default:
          return {
            width: `${this.size - 10}px`,
            height: `${this.size - 10}px`,
            margin: '0px 7px',
            backgroundColor: '#000000',
          }
      }
    },
  },
  methods: {},
}
</script>

<style scoped></style>
